module.exports = __webpack_public_path__ + "img/dots_mtp4.48561015.png";